<template>
  <div class="filterwindow" 
    v-if="openWindow"
    @click="closeForm"></div>
  <div class="fwindow" :class="{'open': openWindow}">
    <div class="filterheader"
      @click="closeForm">
      <Chevprevious class="chev"
        :color="'#1976d2'"
        :hovercolor="'#2650e7'"/>
          {{ backtext }}
    </div>
    <slot></slot>
  </div>
</template>

<script>
import Chevprevious from '@/components/buttons/chevprevious.vue';

export default {
  name: 'FilterWindow',
  props:["openWindow","backtext"],
  emits:["closeWindow"],
  components:{
    Chevprevious
  },
  methods: {
    closeForm(){
      this.$emit("closeWindow");
    }
  }
}
</script>

<style>
.filterheader:hover, .filterheader:hover .chev {
  color: #2650e7 !important;
}

</style>



<style scoped>
.filterwindow{
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 49;
  background-color: rgba(0, 0, 0, 0.35);
}


.filterwindow:hover{
  cursor: pointer;
}

.fwindow{
  background-color: white;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 45%;
  transform: translateX(-100%);
  transition: all 0.5s ease-in-out;
  z-index: -1;
}

.filterheader:hover {
  color: #2650e7;

  cursor: pointer;

}

@media only screen and (max-width: 1400px) {
  .fwindow{
    right: 35%;
  }
}

@media only screen and (min-device-width : 768px) and (max-device-width : 1024px)  {
  .fwindow{
    right: 20%;
  }
}

.fwindow.open{
  z-index: 50;
  transform: translateX(0);
  transition: transform 0.5s ease-in-out;
}

.filterheader{
  display: flex;
  flex-direction: row;
  flex: 1;
  margin: 30px;
  padding-left: .9375rem;
  padding-right: .9375rem;
  align-items: center;
  color:#1976d2;
  font-family: "Montserrat";
  font-size: 16px;
}

@media screen and (min-device-width : 768px) 
and (max-device-width : 1024px)   {

  .filterheader{
    padding-left: 0;
    padding-right: 0;
    margin-left: 25px;
  }
}

.chev{
  margin-right: 10px;
}
</style>